"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.csAdmin = void 0;
var utils_1 = require("../../utils");
var qs = require('qs');
var adminUrl = '/cs';
exports.csAdmin = function (axios) {
    return {
        getCsAdmin: function (getCsAdminRequest) {
            return axios.get(adminUrl + "/admin-registered-cs", getCsAdminRequest);
        },
        getCsAdminSummary: function (getCsAdminSummaryRequest) {
            return axios.get(adminUrl + "/admin-registered-cs/summary", getCsAdminSummaryRequest);
        },
        putCsAdminBulk: function (putCsAdminBulkRequest) {
            return axios.put(adminUrl + "/admin-registered-cs/bulk", putCsAdminBulkRequest.data);
        },
        deleteCsAdmin: function (deleteCsAdmin) {
            return axios.delete(adminUrl + "/admin-registered-cs", {
                params: deleteCsAdmin.params,
                paramsSerializer: function (params) {
                    return qs.stringify(params, {
                        indices: false
                    });
                }
            });
        },
        deleteCsAdminV2: function (request) {
            return axios.delete(adminUrl + "/admin-registered-cs", request);
        },
        postCsAdminRegisteredCs: function (request) {
            return axios.post('/cs/admin-registered-cs', request.data);
        },
        getCs: function (request) {
            return axios.get('/cs', request);
        },
        putCsAdminRegisteredCsCsNo: function (request) {
            var url = utils_1.paramPathchange('/cs/admin-registered-cs/{csNo}', request);
            return axios.put(url, request.data);
        }
    };
};
